import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_public/_layout/rebalance/$rebalance')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/_public/_layout/rebalance/$rebalance"!</div>
}
